import { apiHelper } from '@/utils';
import { API } from '@/constants';

const API_URL = `${API.BASE_URL_API}/v1`;

export const documentService = { getAll, store, show, update, softDelete };

export function getAll(filter = {}) {
    const params = {
        page: filter.pageNumber,
        size: filter.pageSize,
        sortBy: filter.sortBy,
        orderBy: filter.orderBy,
    };
    const searchWords = (filter.searchArray || []).filter((word) => word != null && word !== '');
    if (searchWords.length) params.search_words = searchWords;

    return apiHelper(API_URL).get('/documents', { params });
}

function toFormData(data, method = null) {
    const formData = new FormData();
    formData.append('name', data.name);
    if (data.sequence !== null && data.sequence !== '') formData.append('sequence', data.sequence);
    formData.append('code', data.code);
    formData.append('document_category_uuid', data.documentCategoryUUID);
    formData.append('visible_to_company_uuid', data.visibleToCompanyUUID || '');
    formData.append('is_internal', data.isInternal);
    if (data.isInternal === 1 && data.file instanceof File) formData.append('file', data.file);
    if (data.isInternal === 0) formData.append('file', data.link);
    if (method) formData.append('_method', method);
    return formData;
}

export function store(data) {
    return apiHelper(API_URL).post('/documents', toFormData(data));
}

export function show(uuid) {
    return apiHelper(API_URL).get(`/documents/${uuid}`);
}

export function update(data) {
    return apiHelper(API_URL).post(`/documents/${data.uuid}`, toFormData(data, 'PUT'));
}

export function softDelete(uuid) {
    return apiHelper(API_URL).patch(`/documents/delete/${uuid}`);
}
